// extracted by css-extract-rspack-plugin
export default {"Heading":"Title-module__Heading__pYm88sq"};